import omit from 'lodash/omit';
import { CLICKSTREAM_SCHEMA_DATA } from './clickStreamEventSchema';
export function formNewLaneEventPayload(eventType, newLaneEventData, additionalClickStreamData, isSecondary) {
  if (isSecondary === void 0) {
    isSecondary = false;
  }

  var _CLICKSTREAM_SCHEMA_D = CLICKSTREAM_SCHEMA_DATA(newLaneEventData.triggerLocation, newLaneEventData.triggerObject, newLaneEventData.triggerSource, isSecondary)[eventType],
      envelopeBlock = _CLICKSTREAM_SCHEMA_D.envelopeBlock,
      triggerBlock = _CLICKSTREAM_SCHEMA_D.triggerBlock,
      semanticBlock = _CLICKSTREAM_SCHEMA_D.semanticBlock;
  var properties = Object.assign({
    envelope: Object.assign({
      event_client_start_dtm: new Date().toISOString()
    }, envelopeBlock),
    clickstream_trigger: Object.assign(Object.assign({}, triggerBlock), {}, {
      // TODO: MTT-2939 update input_selector as we start tracking emitter info
      // (like mouse, keyboard, touch)
      input_selector_nm: 'other'
    }),
    semantic: Object.assign({}, semanticBlock),
    omp: Object.assign({
      event_type_nm: eventType
    }, omit(newLaneEventData, 'triggerLocation', 'triggerObject', 'triggerSource', 'exposureData', 'isNbaProcessed', 'position', 'nbaContext'))
  }, additionalClickStreamData);
  return properties;
}